<script lang="ts">
import { defineComponent, toRefs, type PropType } from 'vue'

import Avatar from 'primevue/avatar'

export default defineComponent({
  name: 'AppAvatar',
  components: {
    Avatar,
  },
  props: {
    shape: {
      type: String as () => 'circle' | 'square',
      default: 'circle',
    },
    label: {
      type: String,
      default: '',
    },
    image: {
      type: String as PropType<string | null>,
      default: null,
    },
    icon: {
      type: String,
      default: '',
    },
    size: {
      type: String as () => 'normal' | 'large' | 'xlarge' | undefined,
      default: undefined,
    },
  },
  setup(props) {
    return toRefs(props)
  },
})
</script>

<template>
  <avatar
    :class="size === 'normal' ? '!w-14 !h-14' : ''"
    :shape="shape"
    :label="image ? '' : label"
    :icon="!image && !label ? icon : undefined"
    :image="image || undefined"
    :size="size"
  />
</template>

<style lang="scss"></style>
